import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

interface ReviewActionsBarProps {
  editedCount: number;
  submitting: boolean;
  onConfirm: () => void;
  onReject: () => void;
}

export const ReviewActionsBar = ({ editedCount, submitting, onConfirm, onReject }: ReviewActionsBarProps) => (
  <Stack
    direction="row"
    spacing={2}
    alignItems="center"
    sx={{
      position: 'sticky',
      bottom: 0,
      bgcolor: 'background.paper',
      py: 2,
      mt: 2,
      borderTop: '1px solid',
      borderColor: 'divider',
    }}
  >
    <Button variant="contained" color="primary" disabled={submitting} onClick={onConfirm}>
      Confirm &amp; Save to Submission
    </Button>
    <Button variant="outlined" color="primary" disabled={submitting} onClick={onReject}>
      Reject
    </Button>
    {editedCount > 0 && (
      <Typography variant="body2" color="text.secondary">
        {editedCount} field{editedCount === 1 ? '' : 's'} edited
      </Typography>
    )}
  </Stack>
);
